<template>
  <header
    v-click-outside="closeMobileMenu"
    class="main-header"
  >
    <div class="container container--header">
      <div class="main-header__logo">
        <router-link
          :to="{ name: 'ChooseServicePage' }"
          :aria-label="$t('al.UniversidadedeLisboaHomePage')"
          class="logo"
        >
          <svg
            width="52"
            height="30"
            viewBox="0 0 52 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Sistema Integrado para Gestão de Atendimento</title>
            <path
              d="M11.704 18.456c0-3.2-.416-3.776-4.768-4.928-2.112-.544-2.208-.64-2.208-1.888 0-.96.288-1.344 1.984-1.344 1.216 0 3.104.224 4.288.448l.384-3.104c-1.344-.352-3.232-.544-4.672-.544-4.448 0-5.824 1.376-5.824 4.512 0 3.008.448 3.968 4.256 4.896 2.528.608 2.72 1.088 2.72 2.048 0 1.184-.256 1.568-1.984 1.568-1.6 0-3.328-.288-4.64-.672l-.544 2.976c1.44.512 3.712.896 5.376.896 4.704 0 5.632-1.856 5.632-4.864zM19.448 23V7.416h-3.904V23h3.904zm0-17.792V.696h-3.904v4.512h3.904zM29.24 18.84c-.32 0-.608 0-.896-.032-.512.32-.928.768-.928 1.248 0 .416.256.608.864.672 1.728.192 2.688.288 4.512.48 2.528.288 3.328 1.536 3.328 3.776 0 3.328-1.216 4.64-7.04 4.64-1.792 0-4.256-.256-6.016-.8l.48-2.912c1.664.416 3.424.672 5.248.672 3.104 0 3.712-.224 3.712-1.248 0-.96-.288-1.12-1.472-1.248-1.792-.192-2.528-.288-4.512-.512-2.208-.256-3.072-.992-3.072-2.976 0-1.28.864-2.112 1.632-2.656-1.44-.864-2.112-2.304-2.112-4.192V12.28c.064-3.232 1.76-5.184 6.272-5.184 1.056 0 1.888.128 2.656.32h4.8v1.952c-.544.16-1.184.32-1.728.48.352.672.544 1.536.544 2.432v1.472c0 3.168-1.92 5.088-6.272 5.088zm2.624-6.432c0-1.472-.672-2.176-2.624-2.176-1.92 0-2.592.704-2.592 2.176v1.184c0 1.536.768 2.112 2.592 2.112 1.856 0 2.624-.608 2.624-2.112v-1.184zm19.264.32V23h-3.2l-.288-1.056c-1.408.928-3.072 1.376-4.64 1.376-2.848 0-4.064-1.952-4.064-4.64 0-3.168 1.376-4.384 4.544-4.384h3.744v-1.632c0-1.728-.48-2.336-2.976-2.336-1.408 0-2.944.192-4.32.48l-.48-2.976c1.472-.448 3.616-.736 5.344-.736 4.896 0 6.336 1.728 6.336 5.632zm-3.904 6.688v-2.304h-2.88c-1.28 0-1.632.352-1.632 1.536 0 1.088.352 1.568 1.568 1.568 1.152 0 2.208-.384 2.944-.8z"
              fill="#FFF"
              fill-rule="evenodd"
            />
          </svg>
        </router-link>
        <div
          v-if="service"
          :title="service.title[$i18n.locale()]"
          class="service-acronym"
        >
          {{ service.acronym }}
        </div>
      </div>

      <nav
        id="main-nav"
        ref="nav"
        class="main-nav menu menu-active"
      >
        <ul
          v-if="service"
          class="primary-nav"
        >
          <li
            v-if="service.title"
          >
            <router-link
              id="nav-configs"
              :to="{ name: 'ServicePage', params: { serviceID: service.id }}"
              class="configs"
            >
              {{ $t('reception') }}
            </router-link>
          </li>
          <li>
            <router-link
              id="nav-configs"
              :to="{ name: 'PausedTicketsPage', params: { serviceID: service.id }}"
              class="configs"
            >
              {{ $t('tickets.on.hold') }}
            </router-link>
          </li>
          <li>
            <router-link
              id="nav-configs"
              :to="{ name: 'ServiceSettingsPage', params: { serviceID: service.id }}"
              class="configs"
            >
              {{ $t('manage.service') }}
            </router-link>
          </li>

          <li
            class="has-children mobile-only"
          >
            <!-- <a
              href
              aria-controls="profile-menu"
              @click.prevent="openSubMenu">
              <div class="link-icon">
                <img
                  :src="loggedUser.avatar"
                  hidden
                  alt="cenas"
                  class="user-avatar">
              </div>
              <div class="link-text">cenas</div>
            </a> -->
            <ul
              id="profile-menu"
              class="secondary-nav is-hidden"
            >
              <li
                class="go-back mobile-only"
              >
                <a
                  aria-controls="profile-menu"
                  href
                  @click.prevent="closeSubMenu"
                >
                  <span class="link-text">{{ $t('back') }}</span>
                </a>
              </li>
              <li>
                <button
                  v-if="$auth.isLogged"
                  @click.stop="$auth.logout()"
                >
                  <span class="link-text">{{ $t('logout') }}</span>
                </button>
              </li>
            </ul>
          </li>
          <li
            v-if="isMobile"
            class="has-children mobile-only"
          >
            <a
              href
              @click.prevent="openSubMenu"
            >
              <span class="link-text">{{ $t('language') }}</span>
            </a>
            <ul class="secondary-nav is-hidden">
              <li
                class="go-back mobile-only"
              >
                <a
                  href
                  @click.prevent="closeSubMenu"
                >
                  <span class="link-text">{{ $t('back') }}</span>
                </a>
              </li>
              <li>
                <a
                  v-if="$i18n.locale() === 'en'"
                  href
                  @click.prevent="closeMobileMenu() + setLocale('pt', $auth)"
                >Português</a>
              </li>
              <li>
                <a
                  v-if="$i18n.locale() === 'pt'"
                  href
                  @click.prevent="closeMobileMenu() + setLocale('en', $auth)"
                >English</a>
              </li>
            </ul>
          </li>
        </ul>

        <ul class="utility-nav">
          <li
            v-if="!$auth.isLogged()"
            class="login"
          >
            <a
              href
              class="btn--login"
            >{{ $t('login') }}</a>
          </li>

          <li
            v-else
            class="user"
          >
            <dropdown :size="'lg'">
              <a
                slot="dropdown-trigger"
                :aria-label="$t('al.SotisAccount')"
                href
                class="user-trigger"
                aria-haspopup="true"
              >
                <avatar
                  :src="loggedUser.avatar"
                  :name="loggedUser.name | formatName"
                  class="figure--36"
                />
              </a>
              <div slot="dropdown-panel">
                <div class="dropdown-user__details">
                  <avatar
                    :src="loggedUser.avatar"
                    :name="loggedUser.name | formatName"
                    class="figure--48"
                  />
                  <div class="dropdown-user__text">
                    <div
                      class="name"
                    >
                      {{ loggedUser.name | formatName }}
                    </div>
                    <div class="user-name">
                      {{ loggedUser.username }}
                    </div>
                  </div>
                </div>
                <ul class="dropdown-menu">
                  <li
                    v-if="loggedUser.roles.includes('admin') || Object.keys(loggedUser.acl).length > 1"
                    class="dropdown-menu__item"
                  >
                    <router-link
                      id="nav-services"
                      :to="{ name: 'ChooseServicePage' }"
                      class="dropdown-menu__link"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="24"
                        >
                          <defs>
                            <rect
                              id="a"
                              width="24"
                              height="24"
                              rx="2"
                            />
                          </defs>
                          <g
                            fill="none"
                            fill-rule="evenodd"
                            transform="translate(1 1)"
                          >
                            <path
                              stroke="#8C95A2"
                              stroke-width="1.6"
                              d="M8.66394404 0h3.00299746c.4986262 0 .9028427.40421644.9028427.9028427v19.9068869c0 .4986262-.4042165.9028427-.9028427.9028427H8.66394404c-.1346917-1.2037189-1.14845034-2.1392161-2.37905195-2.1392161-1.23060162 0-2.24436026.9354972-2.37905196 2.1392161H.90284269C.40421644 21.7125723 0 21.3083558 0 20.8097296V.9028427C0 .40421643.40421644 0 .9028427 0h3.00299743c.1346917 1.20371893 1.14845034 2.13921611 2.37905196 2.13921611 1.23060161 0 2.24436025-.93549718 2.37905195-2.13921611z"
                            />
                            <path
                              fill="#8C95A2"
                              d="M3.03527022 10.3107345h5.69136401c.27458225 0 .49717514.2225929.49717514.4971751 0 .2745823-.22259289.4971751-.49717514.4971751H3.03527022c-.27458224 0-.49717514-.2225928-.49717514-.4971751 0-.2745822.2225929-.4971751.49717514-.4971751z"
                            />
                            <rect
                              width="5.44761905"
                              height="1"
                              x="2.53809508"
                              y="13.2851411"
                              fill="#8C95A2"
                              rx=".5"
                            />
                            <path
                              fill="#8C95A2"
                              d="M3.2943505 7.0132766h5.54463233c.3834792 0 .6943505.31087131.6943505.6943505 0 .38347919-.3108713.6943505-.6943505.6943505H3.2943505c-.38347919 0-.6943505-.31087131-.6943505-.6943505 0-.38347919.31087131-.6943505.6943505-.6943505z"
                            />
                          </g>
                        </svg>

                      </span>
                      <span class="link-text">{{ $t('choose.service') }}</span>
                    </router-link>
                  </li>
                  <li
                    v-if="loggedUser.roles.includes('admin')"
                    class="dropdown-menu__item"
                  >
                    <router-link
                      id="nav-configs"
                      :to="{ name: 'AdminPage'}"
                      class="dropdown-menu__link"
                      @click.stop="$auth.logout()"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                        >
                          <g
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path d="M-1-1h24v24H-1z" />
                            <path
                              stroke="#8F95A1"
                              stroke-width="1.6"
                              d="M4.77344981 2.99297831c-.22736476.11614688-.56794301.37653655-.98593898.79453252-.41799597.41799597-.67838564.75857422-.79453252.98593898l1.47637965 2.18911465-.22777954.42518551c-.23685104.44211886-.42975184.90677127-.57549947 1.38805299l-.13972891.461407-2.59100524.50380657C.8567019 9.98391594.8 10.4088644.8 11s.05670189 1.0160841.1353448 1.2589835l2.59100524.5038065.13972891.461407c.14574763.4812818.33864843.9459342.57549947 1.388053l.22777954.4251855-1.47637965 2.1891147c.11614688.2273647.37653655.567943.79453252.985939.41799597.4179959.75857422.6783856.98593898.7945325l2.18911465-1.4763797.42518551.2277796c.44211886.236851.90677127.4297518 1.38805299.5754994l.461407.139729.50380657 2.5910052C9.98391594 21.1432981 10.4088644 21.2 11 21.2s1.0160841-.0567019 1.2589835-.1353448L12.76279 18.47365l.461407-.139729c.4812818-.1457476.9459342-.3386484 1.388053-.5754994l.4251855-.2277796 2.1891147 1.4763797c.2273647-.1161469.567943-.3765366.985939-.7945325.4179959-.417996.6783856-.7585743.7945325-.985939l-1.4763797-2.1891147.2277796-.4251855c.236851-.4421188.4297518-.9067712.5754994-1.388053l.139729-.461407 2.5910052-.5038065C21.1432981 12.0160841 21.2 11.5911356 21.2 11s-.0567019-1.01608406-.1353448-1.25898347L18.47365 9.23720996l-.139729-.461407c-.1457476-.48128172-.3386484-.94593413-.5754994-1.38805299l-.2277796-.42518551 1.4763797-2.18911465c-.1161469-.22736476-.3765366-.56794301-.7945325-.98593898-.417996-.41799597-.7585743-.67838564-.985939-.79453252l-2.1891147 1.47637965-.4251855-.22777954c-.4421188-.23685104-.9067712-.42975184-1.388053-.57549947l-.461407-.13972891L12.2589835.9353448C12.0160841.8567019 11.5911356.8 11 .8S9.98391594.85670189 9.74101653.9353448l-.50380657 2.59100524-.461407.13972891c-.48128172.14574763-.94593413.33864843-1.38805299.57549947l-.42518551.22777954-2.18911465-1.47637965zM11 15.6076923c-2.54475819 0-4.60769231-2.0629341-4.60769231-4.6076923 0-2.54475819 2.06293412-4.60769231 4.60769231-4.60769231 2.5447582 0 4.6076923 2.06293412 4.6076923 4.60769231 0 2.5447582-2.0629341 4.6076923-4.6076923 4.6076923z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">{{ $t('administration') }}</span>
                    </router-link>
                  </li>

                  <li class="dropdown-menu__item">
                    <button
                      v-if="$auth.isLogged"
                      class="dropdown-menu__link"
                      @click.stop="$auth.logout()"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="19"
                        >
                          <g
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path d="M-6-3h24v24H-6z" />
                            <g
                              stroke="#8F95A1"
                              stroke-linecap="round"
                            >
                              <path
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9.076923 1.5h-8V18h7.5750767"
                              />
                              <path
                                stroke-width="1.8"
                                d="M12 6l4 4.0122369L12.0256659 14M6 10h9"
                              />
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">{{ $t('Logout') }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dropdown>
          </li>
        </ul>
        <ul />
      </nav>
    </div>
    <feedback-top-bar />
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'
import Dropdown from '@/components/utils/Dropdown'
import Avatar from '@/components/utils/Avatar'
import FeedbackTopBar from '@/components/utils/FeedbackTopBar'

export default {
  components: {
    Dropdown,
    Avatar,
    FeedbackTopBar
  },
  directives: {
    ClickOutside
  },
  filters: {
    formatName (name) {
      name = name.trim()
      let names = name.split(' ')
      if (names.length < 3) {
        return name
      }
      return `${names[0]} ${names[names.length - 1]}`
    }
  },
  data () {
    return {
      mobileMenuBreakpoint: 1200,
      showMobileMenu: false,
      windowWidth: 0,
      isMobile: false
    }
  },
  computed: {
    ...mapState([
      'service',
      'loggedUser'
    ]),
    isManager () {
      return this.service && ((this.service.acl && this.service.acl[this.loggedUser.username] === 'manager') || this.loggedUser.roles.includes('admin'))
    }
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler (newWidth, oldWidth) {
        if (newWidth < this.mobileMenuBreakpoint) {
          this.isMobile = true
        } else {
          this.closeMobileMenu()
          this.isMobile = false
        }
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  methods: {
    ...mapActions({
    }),
    getWindowWidth () {
      this.windowWidth = window.innerWidth
    },
    openSubMenu (event) {
      const selectedElement = event.target.parentNode
      const subMenuElement = selectedElement.querySelector('ul')
      const parentNav = selectedElement.parentNode
      const utilityNav = parentNav.parentNode.querySelector('ul.utility-nav')
      if (subMenuElement.classList.contains('is-hidden')) {
        selectedElement.classList.add('selected')
        subMenuElement.classList.remove('is-hidden')
        parentNav.classList.add('moves-out')
        if (utilityNav) {
          utilityNav.classList.add('moves-out')
        }
      } else {
        selectedElement.classList.remove('selected')
        parentNav.classList.add('moves-out')
      }
    },
    closeSubMenu (event) {
      const selectedElement = event.target.parentNode
      const currentNav = selectedElement.parentNode
      const previousNav = currentNav.parentNode.parentNode
      const utilityNav = previousNav.parentNode.querySelector('ul.utility-nav')
      currentNav.classList.add('is-hidden')
      previousNav.classList.remove('moves-out')
      if (utilityNav) {
        utilityNav.classList.remove('moves-out')
      }
    },
    closeMobileMenu () {
      if (this.$refs.nav) {
        const navigations = this.$refs.nav.querySelectorAll('.has-children ul')
        const selectedNavigations = this.$refs.nav.querySelectorAll('.has-children a')
        const elementsMovedOut = this.$refs.nav.querySelectorAll('.moves-out')
        for (const navigation of navigations) {
          navigation.classList.add('is-hidden')
        }
        for (const selectedNavigation of selectedNavigations) {
          selectedNavigation.classList.remove('selected')
        }
        for (const elementMovedOut of elementsMovedOut) {
          elementMovedOut.classList.remove('moves-out')
        }
      }
      document.body.classList.remove('scroll-lock')
      this.showMobileMenu = false
      this.$emit('toggle-mobile-menu', this.showMobileMenu)
    }
  }
}

</script>
<style lang="scss">
// import variables
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_buttons.scss";
@import "@/assets/scss/layouts/_header.scss";

// bootstrap container or not?
.container {
  width: 100%;
  // padding-right: 0.9375rem;
  // padding-left: 0.9375rem;
  padding: 0 1.875rem;
  margin-right: auto;
  margin-left: auto;
  // max-width: 71.25rem;
  max-width: 100%;
}

// ================== Main Header Styles
.main-header,
.container--header {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
}

.main-header {
  background: #252039;
  width: 100%;
  min-height: $header-height;
  height: $header-height;
  box-shadow: 0 0.0625rem 0 0 rgba($dark, 0.1);
}

.main-header__logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem 0;
}

.logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 12.5rem;
  height: 100%;
  height: 2rem;
  max-height: 100%;
}

.logo img,
.logo svg {
  width: auto;
  height: 100%;
  object-fit: contain;
}
.main-header__logo .logo svg.ul {
  width: 100%;
  height: auto;
}
.mobile-nav {
  display: flex;
  align-items: center;
}

.mobile-nav li ~ li {
  margin-left: 1.5rem;
}

// ================== Global Menu Styles
.menu .moves-out {
  transform: translateX(-100%);
}

.menu > ul ul {
  position: absolute;
  top: 0;
  left: 100%;
}

.menu .has-children > a::before,
.menu .go-back > a::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.menu .has-children > a::after,
.menu .go-back > a::after {
  position: absolute;
  content: "";
  top: 50%;
  height: 0.625rem;
  width: 0.625rem;
  border: 0.125rem solid $slate;
  border-left: 0;
  border-bottom: 0;
  transform: rotate(45deg) translateY(-50%);
}

.menu .has-children > a::after {
  right: 1rem;
}

.menu .go-back > a {
  padding-left: 2.5rem;
}

.menu .go-back > a::after {
  left: 1rem;
  transform: rotate(-135deg) translateY(50%);
}

// a editar
.menu .is-hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

// IF CSS is disabled, visibility of .mobile-only elements is turned off with attribute "hidden" to simplify document outline,
// but if CSS is enabled they are needed
.mobile-only[hidden] {
  display: flex;

  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.user-side-menu {
  display: flex;
  flex-direction: row;
  img {
    margin-top: 10px;
    margin-right: 10px;
  }
}
// ================== end Global Menu Styles

// ================== Main Nav on mobile
.main-nav {
  position: fixed;
  top: 0;
  bottom: 0;
  right: -#{$menu-mobile--width};
  width: $menu-mobile--width;
  height: 100vh;
  background-color: $dark-600;
  overflow-x: hidden;
  overflow-y: auto;
  // transition: all 600ms cubic-bezier(0.77, 0, 0.175, 1); // INFO, removed due to animation on window resize
}

.main-nav ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 600ms cubic-bezier(0.77, 0, 0.175, 1);
}

.main-nav a {
  position: relative;
  color: #fff;
  display: flex;
  padding: 0 16px;
  width: 100%;
  height: $header-height;
  line-height: $header-height;
  border-bottom: 0.0625rem solid $dark;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
// ================== end of Main Nav on mobile

// ================== Main Nav on desktop
@media screen and (min-width: 1200px) {
  // ================== Global Menu Styles
  .menu > ul ul {
    position: static;
  }

  .menu a {
    color: rgba(255, 255, 255, 0.8);
    display: block;
    font-size: 1rem;
    transition: color 0.2s ease-in-out;

    &:hover,
    &:focus {
      color: rgba(255, 255, 255, 1);
    }

    &:active {
      color: rgba(255, 255, 255, 1);
    }
  }

  .menu .primary-nav li a.router-link-active {
    position: relative;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 0.25rem;
      background-color: #fff;
    }
  }
  // ================== end Global Menu Styles

  .main-nav {
    position: static;
    width: calc(100% - 23rem);
    height: auto;
    background-color: #252039;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    margin-left: auto;
    transition: none;
    overflow: visible;
  }

  // .main-nav ul,
  .main-nav > ul {
    flex-direction: row;
    width: auto;
  }

  .main-nav > ul > li {
    display: flex;
  }

  .main-nav > ul > li > a {
    display: flex;
    align-items: center;
  }

  .main-nav a {
    height: auto;
    line-height: normal;
    white-space: nowrap;
    white-space: normal;
    padding: 0;
    border-bottom: none;
  }

  .main-nav .has-children > a::after,
  .main-nav .go-back > a::after {
    content: initial;
  }

  .main-nav .has-children.has-focus > a,
  .main-nav .has-children:focus-within > a {
    color: $blue-600;
  }

  .main-nav .secondary-nav {
    background-color: $light-blue;
    padding: 2.5rem calc((100vw - 1110px) / 2);
    position: absolute;
    left: 0;
    right: 0;
    top: $header-height;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    transition:
      opacity 0.2s ease-in-out 0.18s,
      visibility 0.2s ease-in-out 0.18s;
  }

  .primary-nav > li ~ li {
    margin-left: 2rem;
  }

  .primary-nav > li.has-children:focus-within .is-hidden {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }

  // focus-within not widely supported yet
  .primary-nav > li.has-children:focus-within > a {
    color: $blue-600;
    box-shadow: inset 0 -0.125rem 0 $blue-600;
  }

  // alternative to focus-within -> add class .has-focus via js
  .primary-nav > li.has-children:hover .is-hidden,
  .primary-nav > li.has-children.has-focus .is-hidden {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }

  .primary-nav > li.has-children > a {
    position: relative;
    box-shadow: inset 0 -0.125rem 0 transparent;
    transition: color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

    &:hover,
    &:focus {
      box-shadow: inset 0 -0.125rem 0 $blue-600;
    }

    &:active {
      box-shadow: inset 0 -0.125rem 0 $blue-700;
    }
  }

  .primary-nav > li.has-children.has-focus > a {
    color: $blue-600;
    box-shadow: inset 0 -0.125rem 0 $blue-600;

    &:active {
      color: $blue-700;
      box-shadow: inset 0 -0.125rem 0 $blue-700;
    }
  }

  p.has-image {
    font-weight: 400;
    margin-top: 1rem;
  }

  p.has-image img {
    margin: 0.5rem 16px 0 0;
  }

  .secondary-nav ul {
    flex-direction: column;
  }

  .secondary-nav .intro-message {
    display: block;
    opacity: 0.65;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    margin-top: 1rem;
    transition: opacity 0.2s ease-in-out;
  }

  .secondary-nav > li {
    flex-basis: 23%;
    margin-right: 2%;
    overflow: hidden;
  }

  .secondary-nav > li > a {
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .secondary-nav > li ul li {
    margin-top: 0.625rem;
  }

  .secondary-nav .intro a:hover p,
  .secondary-nav .intro a:focus p,
  .secondary-nav .intro a:hover span,
  .secondary-nav .intro a:focus span {
    opacity: 1;
  }

  .utility-nav {
    align-items: center;
    margin-left: auto;
  }

  .utility-nav > li ~ li {
    margin-left: 1rem;
  }

  .utility-nav > li > a {
    font-size: 0.875rem;
  }
}

// ================== Main Header icons
.main-header .utility-nav .icon {
  display: none;

  @media screen and (min-width: 1200px) {
    display: flex;

    & + .icon-label {
      display: none;
    }
  }
}

.notifications {
  position: relative;
}

.notifications__count {
  position: absolute;
  top: 0;
  right: -2px;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $blue-600;

  // to animate (?)
  opacity: 0;
  transform: scale(0.1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
}

.notifications__count.is-visible {
  opacity: 1;
  transform: scale(1);
}

.search-trigger,
.notifications-trigger {
  &:hover,
  &:focus {
    .icon--stroke {
      stroke: $blue-600;
    }
  }

  &:active {
    .icon--stroke {
      stroke: $blue-700;
    }
  }
}

.apps-trigger,
.lang-trigger,
.mobile-nav-trigger {
  &:hover,
  &:focus {
    .icon--fill {
      fill: $blue-600;
    }
  }

  &:active {
    .icon--fill {
      fill: $blue-700;
    }
  }
}

.icon-burguer {
  .icon-burguer__top-bar,
  .icon-burguer__center-bar,
  .icon-burguer__bottom-bar {
    transition:
      transform 0.2s ease-in-out,
      transform-origin 0.2s ease-in-out,
      opacity 0.2s ease-in-out;
  }

  .nav-is-visible & {
    .icon-burguer__top-bar {
      transform-origin: top left;
      transform: rotate(45deg) translate(3px, -4px);
    }
    .icon-burguer__center-bar {
      opacity: 0;
    }
    .icon-burguer__bottom-bar {
      transform-origin: bottom left;
      transform: rotate(-45deg) translate(8px, 7px);
    }
  }
}

.icon-lang,
.icon-apps,
.icon-burguer {
  .icon--fill {
    transition: fill 0.2s ease-in-out;
  }
}

.icon-search,
.icon-notifications {
  .icon--stroke {
    transition: stroke 0.2s ease-in-out;
  }
}

.main-header .icon {
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

// Avatars

// user avatar on main-header
.user-container {
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

// user avatar on main-header
.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.12);
  transition: border 0.2s ease-in-out;

  .user-trigger.has-focus &,
  .user-trigger:hover &,
  .user-trigger:focus & {
    border: 2px solid rgba($blue-600, 1);
  }

  .user-trigger:active & {
    border: 2px solid rgba($blue-700, 1);
  }
}

.user-avatar--lg {
  width: 48px;
  height: 48px;
}

.nav-container {
  margin-top: 3.5rem;
}

.navigation {
  // background-color: #1c172f;
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #1c172f), to(#161225));
  background: linear-gradient(to bottom, #1c172f 50%, #161225 100%);
  color: #fff;
  width: 15rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}

.nav-left {
  width: 12.5rem;
}

.nav-top {
  padding-bottom: 1.875rem;
  border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.1);
}

.nav-middle {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
}

.nav-middle .service-section {
  // flex-grow: 1;
  display: flex;
}

.nav-middle li a {
  // display: block;
  background-color: transparent;
  // border-left: 0.25rem solid transparent;
  // padding: 1.25rem 1.875rem 1.25rem 3.75rem;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  // -webkit-transition: all .3s ease;
  transition: all 0.3s ease;
  background-position: 1.875rem 50%;
  background-repeat: no-repeat;
}

.nav-middle li a.active {
  background-color: rgba(255, 255, 255, 0.1);
  // border-left: 0.25rem solid #0073e0
}

.nav-middle li a:active {
  background-color: rgba(255, 255, 255, 0.06);
  border-left: 0.25rem solid #0076dc;
}

</style>
